// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9gpZe","col":"styles_col__jNxcu"};